"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rxjs = require("rxjs");

var _ajax = require("rxjs/ajax");

var _operators = require("rxjs/operators");

var _fastStableStringify = _interopRequireDefault(require("fast-stable-stringify"));

var _sha = _interopRequireDefault(require("sha1"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = function _default(_ref) {
  var apikey = _ref.apikey,
      apiUrl = _ref.apiUrl,
      queryId = _ref.queryId,
      trackLatency = _ref.trackLatency; // new cache for this instantiation
  // really we should use some browser storage for the cache,
  // and then we can load data in ther service worker... ultimately.

  var cache = window.__ABCLOUD_RESOLVER_CACHE__ || {};
  return function (_ref2) {
    var queryName = _ref2.queryName,
        args = _ref2.args;
    return (0, _rxjs.of)({
      queryName: queryName,
      args: args
    }).pipe((0, _operators.switchMap)(function (_ref3) {
      var queryName = _ref3.queryName,
          args = _ref3.args; // why don't we request with this instead of queryName and args?

      var featureId = "".concat(queryName, "_").concat((0, _sha.default)((0, _fastStableStringify.default)(args)));
      var requestTime = window.performance.now();
      return cache[featureId] ? (0, _rxjs.of)(cache[featureId]) : (0, _ajax.ajax)({
        // trying api on same domain
        // ${SERVER_URL}
        url: "".concat(apiUrl, "/resolve-feature/").concat(queryName, "?apikey=").concat(apikey, "&args=").concat(encodeURIComponent(JSON.stringify(args)), "&queryid=").concat(queryId),
        crossDomain: true,
        //   headers: {
        //       "x-api-key": apiKey
        //   },
        createXHR: function createXHR() {
          return new XMLHttpRequest();
        }
      }).pipe((0, _operators.take)(1), (0, _operators.map)(function (_ref4) {
        var response = _ref4.response;
        cache[featureId] = response;

        if (trackLatency) {
          trackLatency({
            featureId: featureId,
            queryName: queryName,
            args: args,
            latency: parseInt(window.performance.now() - requestTime)
          });
        }

        return response;
      }));
    }));
  };
};

exports.default = _default;